<template>
	
  <div class="home">
<div class="works-ban">
	
		<p> 
會員中心                              </p>
	</div>
   <div class="mem-full">
 <Center title='8' />
	
<div class="mem-con">
	<div class="mem-jin">
		會員中心 / <b>優惠券</b>
	</div>
	<div class="cen-ord">
		 <el-tabs v-model="activeName" >
		    <el-tab-pane label="接收優惠券" name="1"></el-tab-pane>
		   
		  </el-tabs>
		 
		  <div class="address">
		  	<div class="men-l1">
		  		<div class="re-tit">
					<el-row>
						<el-col span="8">定額/明細</el-col>
						<el-col span="8">適用範圍</el-col>
						<el-col span="8">有效期</h4></el-col>
					</el-row>
		  				  
		  		</div>
		  		<div class="re-con">
					<el-row v-for="item in news" class="lik">
						<el-col span="8">
							<h6>{{item.money}} 元券{{item.title}}</h6>
							<p v-if="item.man==0">無門檻</p>
							<p v-else>超過 {{item.man}} 元减  {{item.money}} 元</p>
						</el-col>
						<el-col span="8">
							{{item.tiaojian}}
						</el-col>
						<el-col span="5">
							<div class="coupon-li">
							<p>{{item.startTime}}</p>
							<p class="res-to">To</p>
							<p>{{item.endTime}} </p>
							</div>
						</el-col>
						<el-col span="3">
						<div class="h-button" v-if="item.if_ke_lingqu==1" @click="receive(item.id)">領取</div>
						<div class="h-button but" v-else>不可領取</div>
						</el-col>
				 </el-row>
		  		</div>
		  	</div>
	
		  </div>
	</div>


   <div class="page">
	     
	     <el-pagination
	       layout="prev, pager, next"
	       :total="total"
		   @current-change="pick">
	     </el-pagination>
	   </div>
	
</div>
   </div>

    </div>
</template>
<script>

import Center from '@/components/center/center'

export default {
  components: {
   Center


  },
  data() {
    return {
		page:1,
		pagenum:100,
		moren:false,
		activeName: '1',
		sun:'',
		total:'',
		news:'',
           ruleForm: {
           	first_name:'',
           	last_name:'',
         
           	phone:'',
           	nickname:'',
           	country:'',
           	identity_id:'',
           	address_line:'',
           	province:'',
           	city:'',
           	postcode:'',
			moren: 0,
          
               
                 },
                 rules: {
                 	
                 	   first_name: [
                 	    { required: true, message: 'Please fill in First name', trigger: 'blur' },
                 ],last_name: [
                 	    { required: true, message: 'Please fill in Last name', trigger: 'blur' },
                 ],phone: [
                 	    { required: true, message: 'Please fill in Phone', trigger: 'blur' },
                 ],country: [
                 	    { required: true, message: 'Please fill in Country', trigger: 'change' },
                 ],address_line: [
                 	    { required: true, message: 'Please fill in Address Line 1', trigger: 'blur' },
                 ],province: [
                 	    { required: true, message: 'Please fill in Province', trigger: 'blur' },
                 ],city: [
                 	    { required: true, message: 'Please fill in City', trigger: 'blur' },
                 ],postcode: [
                 	    { required: true, message: 'Please fill in Postcode', trigger: 'blur' },
                 ],nickname: [
                 	    { required: true, message: 'Please fill in nickname', trigger: 'blur' },
                 ],identity_id: [
                 	    { required: true, message: 'Please fill in ID', trigger: 'blur' },
                 ]
                  
                   }
          };
  },  mounted() {
	  
	  this.id = this.$route.query.id

		this.sandMate();
		this.sandCase();
		},methods: {
			
		
			 receive(id){
			   	this.$axios({
			   	  method: "post",
			   	  url: "service.php?action=users_yhqLingqu",
			   	  data: {id:id},  
			   	}).then((res) => {
			   		let data=res.data;
			   	
			   		if(data.code==1){
			   			
			   		this.$message.success(data.message);
			
			   		}else{  
			   			this.$message.error(data.message);
			   			      
			   		}
			   	 
			   	});
			   
			   },
			 sandCase(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=userAddress_country",
			  	  data: {},  
			  	}).then((res) => {
			  		let data=res.data;
			  	
			  		if(data.code==1){
			  			this.sun=data.data;
			  		}
			  	 
			  	});
			  
			  },pick(item){
							this.page=item;
							this.sandMate()
						},
			 sandMate(){
			 	this.$axios({
			 	  method: "post",
			 	  url: "service.php?action=users_yhqList",
			 	  data: {page:this.page,scene:1},  
			 	}).then((res) => {
			 		let data=res.data;
			 
			 		if(data.code==1){
			 	
			 							
			 			this.news=data.data;
			 			this.total=data.count
			 			
			 		}
			 	 
			 	});
			 
			 },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }, handleClick() {
				  this.sandMate()
      
      }
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;

			height: 50px;
			line-height: 50px;
			background: #000;
			color: #FFFFFF;

		}
		.h-button:hover{
			background-color: #333333;
		}
		.but{
			background: #888;
		}
		.but:hover{
			background: #888;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			h4{
				font-size: 26px;
				
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{

}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}


	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}
.member{
	width: 247px;
	height: 687px;
	background: #F8F8F8;
	padding: 30px;
	h5{
		line-height: 50px;
		background: url(../../assets/bot1.png) no-repeat bottom left;
	}
	.con{
		li{
			border-bottom:1px solid #eeeeee;
			padding: 20px;
		}
		h6{
			line-height: 40px;
		}
		p{
			display: flex;
			line-height: 40px;
			align-items: center;
			color: #777777;
			span{
				display: inline-block;
				width: 6px;
				height: 6px;
				background: #636363;
				border-radius: 50%;
				margin-right: 10px;
			}
		}
		.act{
			color: #000000;
		}
	}

}
.mem-full{
	display: flex;
	width: 1200px;
	margin: 20px auto;
}

.mem-con{
	flex: 1;
	margin-left: 20px;
	.men-l1{
		border: 1px solid #D2D2D2;
		margin-bottom: 20px;
		.re-tit{
			padding: 20px;
			border-bottom: 1px solid #D2D2D2;
			background: #F8F8F8;
			h4{
				margin-left: 20px;
			}
			
		}
		.re-con{
			padding:0 20px;
			.lik{
				border-bottom: 1px solid #E2E2E2;
				padding: 20px 0;
				
			}
			.coupon-li{
				width: 80px;
				text-align: center;
			}
			h6{
				font-size: 16px;
				margin-bottom: 10px;
			}
			p{
				font-size: 14px;
			}
			.res-to{
				font-size: 16px;
				margin: 10px 0;
				
			}
		}
	}
}
.add-for{
padding: 30px;
	background: #F8F8F8;
	border: 1px solid #D2D2D2;
	

}
.add-ship{
	margin: 20px 0;
}
.add-set{
	margin-left: 10px;
}
.cen-ord1{
background: #F8F8F8;
padding: 20px;
margin-bottom: 20px;
}
.cen-ord2{
	width: 100%;
}
.cen-ord3{
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content:space-evenly;
}
	.page{
		text-align: center;
		margin:50px auto;
	}
	.mem-con-it{
		height: 100px;
	}
	.mem-ord-det{
		margin-top: 15px;
		text-decoration: underline;
	}

</style>